import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=fe851230&scoped=true"
import script from "./TaskForm.vue?vue&type=script&lang=ts"
export * from "./TaskForm.vue?vue&type=script&lang=ts"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=fe851230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe851230",
  null
  
)

export default component.exports